<template>
  <div id="NotifyLayout">
    <BANotify ref="BAnotify" />
  </div>
</template>
<script>
import BANotify from './components/BANotify' // Level 1-3 BA告警訊息
export default {
  components: {
    BANotify
  },
  data () {
    return {
    }
  },
  watch: {
    $route (to, from) {
      if (window.location.href.indexOf('login') > -1) {
        localStorage.removeItem('BA-alert')
      } else if (this.$isServiceEnabled(24)) {
        // 有開BA功能
        this.setPosition() // 重整頁面、頁面跳轉時，重新定位告警列表top
        this.getUnfinishedEvent()
        this.getPrivateUnfinishedEvent()
      }
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.setPosition()
    })
    if (window.location.href.indexOf('login') > -1) {
      localStorage.removeItem('BA-alert')
    } else {
      this.getBAAuth()
    }
  },
  unmounted () {
    window.removeEventListener('resize', () => {
      this.setPosition()
    })
  },
  methods: {
    // 判斷有無開啟BA功能
    async getBAAuth () {
      if (this.$isServiceEnabled(24)) { // 社區有開BA功能
        this.setPosition() // 重整頁面、頁面跳轉時，重新定位告警列表top
        this.getUnfinishedEvent()
        this.getPrivateUnfinishedEvent()
        // 註冊接收BA推播告警事件，並存入 localStorage
        if ('serviceWorker' in navigator) {
          navigator.serviceWorker.addEventListener('message', event => {
            // eslint-disable-next-line eqeqeq
            if (event.data.FeatureName == 'BA-alert') {
              let baAlertType = 'BA-alert'
              if (event.data.TabletId) baAlertType = 'BA-private-alert'
              const BAEvent = {
                data: event.data,
                featureName: baAlertType,
                title: event.data.title
              }
              BAEvent.data.TagLevel = BAEvent.data.TagLevel ? Number(BAEvent.data.TagLevel) : 1
              BAEvent.data.timeSince = BAEvent.data.EventCreatedTime ? this.$timeSince(BAEvent.data.EventCreatedTime) : ''
              const localStorageData = localStorage.getItem(baAlertType) ? JSON.parse(localStorage.getItem(baAlertType)) : { level4: [], other: [] }
              let error = false
              if (BAEvent.data.TagLevel === 4) {
                // eslint-disable-next-line eqeqeq
                error = localStorageData.level4.some(item => item.data.Id == BAEvent.data.Id)
                if (!error)
                { localStorageData.level4.unshift(BAEvent) }
              } else {
                // eslint-disable-next-line eqeqeq
                error = localStorageData.other.some(item => item.data.Id == BAEvent.data.Id)
                if (!error)
                { localStorageData.other.unshift(BAEvent) }
              }
              localStorage.setItem(baAlertType, JSON.stringify(localStorageData))
              const newStorageEvent = new Event('storage')
              newStorageEvent.key = baAlertType
              window.dispatchEvent(newStorageEvent)
            }
          })
        }
      }
    },
    // 取得目前未結案告警事件列表，用 Level[ 1-3 ,4 ]分類，並存入 localStorage
    // Level1-3 component 內部都有建立 localStorage 監聽器，所以不需要 props
    // 重新取得時間: 重整頁面、頁面跳轉
    async getUnfinishedEvent () {
      const res = await this.$getJWTToken()
      if (res.status === 200) {
        apiBaAlert.getUnfinishedEvent().then(res => {
          // 存入localstorage
          const newData = {
            level4: [],
            other: []
          }
          res.data.forEach(item => {
            const obj = {
              data: {
                Id: item.EventId,
                TagLevel: item.TagLevel,
                AssetPosition: item.AssetPosition,
                EventCreatedTime: item.CreatedTime,
                timeSince: item.CreatedTime ? this.$timeSince(item.CreatedTime) : ''
              },
              featureName: 'BA-alert',
              title: `${item.TagMean}`
            }
            // eslint-disable-next-line eqeqeq
            if (item.TagLevel == 4) { newData.level4.push(obj) } else { newData.other.push(obj) }
          })
          localStorage.setItem('BA-alert', JSON.stringify(newData))
          const newStorageEvent = new Event('storage')
          newStorageEvent.key = 'BA-alert'
          window.dispatchEvent(newStorageEvent)
        }).catch(err => {
          console.log('錯誤訊息：', err.response)
        })
      }
    },
    async getPrivateUnfinishedEvent () {
      const res = await this.$getJWTToken()
      if (res.status === 200) {
        apiBaAlert.getPrivateUnfinishedEvent().then(res => {
          // 存入localstorage
          const newData = {
            level4: [],
            other: []
          }
          res.data.forEach(item => {
            const obj = {
              data: {
                Id: item.EventId,
                TagLevel: item.TagLevel,
                AssetPosition: item.AssetPosition,
                EventCreatedTime: item.CreatedTime,
                timeSince: item.CreatedTime ? this.$timeSince(item.CreatedTime) : ''
              },
              featureName: 'BA-alert',
              title: `${item.TagName}-異常`
            }
            // eslint-disable-next-line eqeqeq
            if (item.TagLevel == 4)
            { newData.level4.push(obj) }
            else
            { newData.other.push(obj) }
          })
          localStorage.setItem('BA-private-alert', JSON.stringify(newData))
          const newStorageEvent = new Event('storage')
          newStorageEvent.key = 'BA-private-alert'
          window.dispatchEvent(newStorageEvent)
        }).catch(err => {
          console.log('錯誤訊息：', err.response)
        })
      }
    },
    setPosition () {
      // 瀏覽器寬度變更時，刷新取得header高度，讓推播列表的定位持續在header之下
      this.$nextTick(function () {
        if (!document.getElementById('NotifyLayout')) return
        document.getElementById('NotifyLayout').style.top = document.getElementById('app-header').offsetHeight + 24 + 'px'
        document.getElementById('NotifyLayout').style['max-height'] = `calc( 100vh - ${document.getElementById('app-header').offsetHeight}px )`
      })
    }
  }
}
</script>

<style lang="sass" scoped>
#NotifyLayout
  z-index: 2000
  position: fixed
  top: 137px
  right: 23px
  overflow-y: auto
  overflow-x: hidden
  display: flex
  max-height: calc( 100vh - 110px )
  flex-direction: column
  transition: all 0.5s
</style>
